export const processVacancyTitleFromFolder = (
  folderPath: string,
  fallback = 'Вакансия',
): string => {
  const parts = folderPath.split('/').filter(Boolean);
  return parts[parts.length - 1] || folderPath.trim() || fallback;
};

export const listProcessVacancyCards = (folderPath: string): string[] => [
  processVacancyTitleFromFolder(folderPath),
];

const normalizeVacancyTitle = (value: string): string => (
  value.toLowerCase().replace(/ё/g, 'е').replace(/\s+/g, ' ').trim()
);

export const eventVacancyMatchesTitle = (eventVacancy: string, vacancyTitle: string): boolean => {
  const eventNorm = normalizeVacancyTitle(eventVacancy);
  const titleNorm = normalizeVacancyTitle(vacancyTitle);
  if (!eventNorm || !titleNorm) return false;
  return eventNorm === titleNorm || eventNorm.endsWith(`/${titleNorm}`);
};

export const stageEventsForCurrentVacancy = <T>(
  stageEvents: T[],
  vacancyTitle: string,
  getEventVacancy: (event: T) => string,
): T[] => {
  const matched = stageEvents.filter((event) => {
    const eventVacancy = getEventVacancy(event);
    if (!eventVacancy) return true;
    return eventVacancyMatchesTitle(eventVacancy, vacancyTitle);
  });
  // Stages saved with a resume title or a full folder path still belong to the
  // candidate's current folder vacancy, so keep the whole chain when nothing matches.
  return matched.length > 0 ? matched : stageEvents;
};

const PROCESS_STAGE_FIELD_LABELS: Record<string, string> = {
  offer_date: 'Дата оффера',
  valid_until: 'Срок действия оффера',
  accepted_at: 'Дата принятия оффера',
  start_date: 'Дата выхода',
  department: 'Подразделение',
  manager: 'Руководитель',
  position: 'Должность',
  employment_type: 'Тип занятости',
  probation_period: 'Испытательный срок',
};

const PROCESS_STAGE_DATE_FIELDS = new Set([
  'offer_date',
  'valid_until',
  'accepted_at',
  'start_date',
]);

const formatHistoryDate = (value: string): string => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('ru-RU');
};

export const formatProcessStageHistoryDetails = (
  payload: Record<string, unknown>,
  options?: {
    comment?: string;
    statusLabel?: string;
  },
): string => {
  const fromStage = String(payload.from_stage || '—');
  const toStage = String(payload.to_stage || payload.stage || '—');
  const parts = [`Этап изменён: ${fromStage} -> ${toStage}`];

  if (options?.statusLabel) {
    parts.push(`Статус: ${options.statusLabel}`);
  }

  Object.entries(PROCESS_STAGE_FIELD_LABELS).forEach(([field, label]) => {
    const raw = payload[field];
    if (raw === undefined || raw === null || raw === '') return;
    const value = PROCESS_STAGE_DATE_FIELDS.has(field)
      ? formatHistoryDate(String(raw))
      : String(raw);
    parts.push(`${label}: ${value}`);
  });

  if (options?.comment) {
    parts.push(options.comment);
  }

  return parts.join('. ');
};
